import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import FundAmountForm from '../../components/Forms/FundAmountForm';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import { useMenu } from '../../hooks/useMenu';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const FundAmount = () => {
  const { activeMenu, activeItem } = useMenu();
  const { t } = useTranslation();
  const { BrokerName } = useSelector(selectSettings);
  const formId = 'fundAmount_form';
  const [eventType, setEventType] = useState(null);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
      formId={formId}
      setEventType={setEventType}
    >
      <Helmet>
        <title>
          {t('titleTagAmount', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <FundAmountForm
        nextPath={activeItem?.nextPath}
        formId={formId}
        setEventType={setEventType}
        eventType={eventType}
      />
    </OnBoardingContainer>
  );
};

export default FundAmount;
